import { PropsWithChildren } from 'react';

import { useOfflineStationEffect } from '~hooks/useOfflineStationEffect';
import { useUnavailableBatteriesEffect } from '~hooks/useUnavailableBatteriesEffect';
import { useStationInformationContext } from '~providers';

export const WithStationOfflineEffect = ({ children }: PropsWithChildren) => {
  const {
    stationOnlineStatus,
    isFetchingStationInformation,
    isFetchedStationInformation,
  } = useStationInformationContext();

  useOfflineStationEffect();
  useUnavailableBatteriesEffect();

  if (
    stationOnlineStatus === true &&
    isFetchingStationInformation &&
    !isFetchedStationInformation
  ) {
    return null;
  }

  return <>{children}</>;
};
